import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from '@material-ui/core';

import { useLanguage } from '../../../components/hooks/useLanguage/useLanguage';
import { useStyles } from '../useStyles';
import img1 from './images/img1.png';
import img2 from './images/img2.png';
import img3 from './images/img3.png';
import img4 from './images/img4.png';
import img4Eng from './images/img4Eng.png';
import img5 from './images/img5.png';

export const Article = memo(() => {
    const { t: translate } = useTranslation();
    const { isEng } = useLanguage();
    const classes = useStyles();

    return (
        <>
            <p>{translate('whatsNew.article1Top')}</p>
            <div>
                <img src={img1} className={classes.image} />
                <p>{translate('whatsNew.article1Bottom')}</p>
            </div>
            <Divider />
            <div>
                <p>{translate('whatsNew.article2Top')}</p>
                <img src={img2} className={classes.image} />
            </div>
            <Divider />
            <div>
                <p>{translate('whatsNew.article3Top')}</p>
                <img src={img3} className={classes.image} />
                <p>{translate('whatsNew.article3Bottom')}</p>
            </div>
            <div>
                <p>{translate('whatsNew.article5Top')}</p>
                <img src={img5} className={classes.image} />
            </div>
            <Divider />
            <div>
                <p>{translate('whatsNew.article4Top')}</p>
                <img src={isEng ? img4Eng : img4} className={classes.image} />
            </div>
        </>
    );
});

Article.displayName = 'Article';
